<template>
  <div class="container is-fluid">
  <username-modal v-show="showUsernameModal" @close="showUsernameModal = false"></username-modal>
    <div class="columns">
      <div class="column">
        <p class="title is-1" align="center">Welcome Back {{ user.firstName }}</p>
        <div v-if="deviceNotSynced" class="content">
            <p class="title is-3" align="center">Please Sync Device To View Daily Progress</p><br><br>
            <p class="title is-6" align="center"> “From all of us at KNOSIS, Thank you for participating in our revolutionary platform’s Closed BETA Test.</p>
            <p class="title is-6" align="center">You are part of a select group of people who will be testing this proprietary platform for the very first time.</p>
            <p class="title is-6" align="center">Your participation and feedback will be important for us to improve upon our methodology as we seek to revolutionize</p>
            <p class="title is-6" align="center"> the healthcare industry by engaging users to live healthier lifestyles. - Wilman Vergara, Founder and CEO”</p>
        </div>

        <div class="columns is-centered">
          <div v-if="summaryReady" class="column is-one-third">
            <div class="flip-container">
              <div class="flipper">
                <radial-progress-bar
                  :diameter="250"
                  :completed-steps="achievedSteps" :total-steps="goalSteps"
                  :startColor="stepsStartColor" :stopColor="stepsEndColor" :innerStrokeColor="stockColor">
                  <p class="title is-3">Steps</p>
                  <div class="front">
                    <p class="title is-5" align="center">Goal: {{ goalSteps }}<br>Completed: {{ achievedSteps }}</p>
                  </div>
                  <div class="back">
                    <p class="title is-4">{{ stepsPercent }}%</p>
                  </div>
                </radial-progress-bar>
              </div>
            </div>
            <div class="flip-container">
              <div class="flipper">
                <radial-progress-bar
                  :diameter="250"
                  :completed-steps="achievedCalorieOut" :total-steps="goalCalorieOut"
                  :startColor="caloriesStartColor" :stopColor="caloriesEndColor" :innerStrokeColor="stockColor1">
                  <p class="title is-3">Calories</p>
                  <div class="front">
                    <p class="title is-5" align="center">Goal: {{ goalCalorieOut }}<br>Completed: {{ achievedCalorieOut }}</p>
                  </div>
                  <div class="back">
                    <p class="title is-4">{{ caloriePercent }}%</p>
                  </div>
                </radial-progress-bar>
              </div>
            </div>
            <div class="flip-container">
              <div class="flipper">
                <radial-progress-bar
                  :diameter="250"
                  :completed-steps="achievedFloors" :total-steps="goalFloors"
                  :startColor="floorsStartColor" :stopColor="floorsEndColor" :innerStrokeColor="stockColor2">
                  <p class="title is-3">Floors</p>
                  <div class="front">
                    <p class="title is-5">Goal: {{ goalFloors }}<br>Completed: {{ achievedFloors }}</p>
                  </div>
                  <div class="back">
                    <p class="title is-4">{{ floorPercent }}%</p>
                  </div>
                </radial-progress-bar>
              </div>
            </div>
          </div>
          <div v-if="summaryReady" class="column is-one-third">
            <figure class="image">
              <!-- This is where the didimo modal will be called - figure class image tag will resize responsively -->
              <didimoModal></didimoModal>
            </figure><br><br>
            <div v-if="summaryReady" class="content">
              <article class="media">
                <div class="media-left">
                  <p class="title is-5">Distance Traveled</p>
                </div>
                <div class="media-content">
                  <div class="content">
                    <p class="title is-6">Goal: {{goalDistance}} miles<br>Completed: {{achievedDistance}} miles</p><br>
                  </div>
                </div>
              </article>
              <progress class="progress is-large is-primary"
                :value="achievedDistance" :max="goalDistance">
              </progress>

            </div>
          </div>
          <div v-if="summaryReady" class="column is-one-third">
            <p class="title" align="center">Tracker Minutes</p>
            <div class="content">
              <article class="media">
                <div class="media-left">
                  <p class="title is-6">Inactive: {{ inactiveMinutes }}</p>
                </div>
                <div class="media-content">
                  <progress class="progress is-small is-danger"
                    :value="inactiveMinutes" :max="goalMinutes">
                  </progress>
                </div>
              </article>
              <article class="media">
                <div class="media-left">
                  <p class="title is-6">Lightly Active: {{ lightMinutes }}</p>
                </div>
                <div class="media-content">
                  <progress class="progress is-warning"
                    :value="lightMinutes" :max="goalMinutes">
                  </progress>
                </div>
              </article>
              <article class="media">
                <div class="media-left">
                  <p class="title is-6">Fairly Active: {{ fairMinutes }}</p>
                </div>
                <div class="media-content">
                  <progress class="progress is-medium is-link"
                    :value="fairMinutes" :max="goalMinutes">
                  </progress>
                </div>
              </article>
              <article class="media">
                <div class="media-left">
                  <p class="title is-6">Very Active: {{ activeMinutes }}</p>
                </div>
                <div class="media-content">
                  <progress class="progress is-large is-success"
                    :value="activeMinutes" :max="goalMinutes">
                  </progress>
                </div>
              </article>
            </div>

            <div class="ball">
              <p class="title" align="center">{{ rank }}</p>
              <figure class="image">
                <!--<img :src="rankSource">-->
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as firebase from 'firebase'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import VueLocalStorage from 'vue-localstorage'
import {getDidimoFBX} from './Avatar/didimoModal.vue'
import didimoModal from './Avatar/didimoModal.vue'
import Apollo from '../assets/Badges/ApolloBadgeGold.png'
import Artemis from '../assets/Badges/ArtemisBadgeBronze.png'
import Athena from '../assets/Badges/AthenaBadgeGold.png'
import Hera from '../assets/Badges/HeraBadgePlatinum.png'
import Poseidon from '../assets/Badges/PoseidonBadgeBronze.png'
import Zeus from '../assets/Badges/ZeusBadgePlatinum.png'
import Vesta from '../assets/Badges/VestaBadgeSilver.png'
import Odysseus from '../assets/Badges/OdysseusBadgeSilver.png'
import logo from '../assets/logo.png'
import { mapGetters } from 'vuex'
import usernameModal from './usernameModal'

export default {
  data() {
    return {
      rank: 'No Rank',
      accessToken: '',
      tempUsername: '',
      // gender: null,

      //Radiant colors for radial progress bars
      caloriesStartColor: "#ff9933",
      caloriesEndColor: "#ff0000",
      stepsStartColor: "#e600e6",
      stepsEndColor: "#990099",
      floorsStartColor: "#4e84c4",
      floorsEndColor: "#f4edca",
      stockColor: "#ff6347",
      stockColor1: "#00bfff",
      stockColor2: "#dcdcdc",

      //v-if booleans
      deviceNotSynced: true,
      summaryReady: false,
      showUsernameModal: false,

      //Hardcoded baseline goal values for fitness trackers
      //Overwritten by tracker is applicable
      goalSteps: 10000,
      goalDistance: 10,
      goalCalorieOut: 1000,
      goalMinutes: 100,
      goalFloors: 10,

      //Achieved values of fitness tracker data
      achievedSteps: 0,
      achievedDistance: 0,
      achievedCalorieOut: 0,
      inactiveMinutes: 0,
      lightMinutes: 0,
      fairMinutes: 0,
      activeMinutes: 0,
      achievedFloors: 0,

      //Percentages calculated from achieved/goals
      stepsPercent: 0,
      distancePercent: 0,
      caloriePercent: 0,
      floorPercent: 0,
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
    // rankSource() {
    //   this.getRankData()
    //   return this.setRank()
    // }
  },
  watch: {
  },
  created() {
    firebase.database().ref('/users/').child(firebase.auth().currentUser.uid).once('value')
      .then((data) => {
        const username = data.child('username').val()
        if (typeof username === 'undefined' || username == null || username == '') {
          this.showUsernameModal = true
        }

        const adminLevel = data.child('admin').val()
        if (typeof adminLevel === 'undefined' || adminLevel == null || adminLevel == '') {
          firebase.database().ref('/users/').child(firebase.auth().currentUser.uid).update({
              admin: false
          })
          .catch((error) => { console.log(error) })
        }

        const fbAccess = data.child('fitbitAccessToken').val()
        if (typeof fbAccess === 'undefined' || fbAccess == null || fbAccess == '') {
          firebase.database().ref('/users/').child(firebase.auth().currentUser.uid).update({
              fitbitAccessToken: ''
          })
          .catch((error) => { console.log(error) })
        }

        const fitID = data.child('fitbitID').val()
        if (typeof fitID === 'undefined' || fitID == null || fitID == '') {
          firebase.database().ref('/users/').child(firebase.auth().currentUser.uid).update({
              fitbitID: ''
          })
          .catch((error) => { console.log(error) })
        }
      })
      .catch((error) => { console.log(error) })
  },
  mounted() {
    this.setAccessToken()
    this.getProgressData()
    this.getProfileData()

    this.$root.$on('close', function() {
      this.showUsernameModal = false
    })
  },
  methods: {

    // //If FITBIT authorization is confirmed set a cookie as the access token
    setAccessToken() {
      if(window.location.href.indexOf("state=confirm") > -1) {
        this.$cookies.set('oauth_access_token',window.location.href.split('access_token=')[1].split('&')[0],'1m')
        this.accessToken = window.location.href.split('access_token=')[1].split('&')[0]
        firebase.database().ref('users').child(this.user.id).update({
          fitbitAccessToken: this.accessToken
        })
      }
    },

    //Get users fitbit profile ID for challenge needs - store to firebase
    getProfileData() {
      if(this.$cookies.isKey('oauth_access_token')) {
        var AuthString = 'Bearer '+(this.$cookies.get('oauth_access_token'))
        axios.defaults.headers.common['Authorization'] = AuthString

        //Call for profile data
        axios({ method: 'get',
          url: 'https://api.fitbit.com/1/user/-/profile.json'
        })
        .then(response => {
          var obj = JSON.parse(JSON.stringify(response.data))
          firebase.database().ref('users').child(firebase.auth().currentUser.uid).update({
            fitbitID: obj.user.encodedId
          })
        })
        .catch(error => { console.log(error) })
      } else {
        this.deviceNotSynced = true
      }
    },

    //Check to make sure access is granted to FITBIT Web API by checking for access token
    //Access granted -> get todays tracker data
    getProgressData() {
      if(this.$cookies.isKey('oauth_access_token')) {
        var AuthString = 'Bearer '+(this.$cookies.get('oauth_access_token'))
        axios.defaults.headers.common['Authorization'] = AuthString

        //Call for 1 month of data
        axios({ method: 'get',
          url: 'https://api.fitbit.com/1/user/-/activities/date/today.json'
        })
        .then(response => {
          this.setProgressData(JSON.parse(JSON.stringify(response.data)))
        })
        .catch(error => { console.log(error); })
      } else {
        this.deviceNotSynced = true
      }
    },

    //Update charts with progress data
    setProgressData(val) {
      //Set goals
      this.goalSteps = parseInt(val.goals.steps)
      this.goalDistance = parseInt(val.goals.distance)
      this.goalCalorieOut = parseInt(val.goals.caloriesOut)
      this.goalMinutes = parseInt(val.goals.activeMinutes)
      if(isNaN(val.goals.floors)) {
        this.goalFloors = 10
      } else {
        this.goalFloors = val.goals.floors
      }

      //Set achieved
      this.achievedSteps = parseInt(val.summary.steps)
      this.achievedDistance = parseInt(val.summary.distances[0].distance)
      this.achievedCalorieOut = parseInt(val.summary.caloriesOut)
      this.inactiveMinutes = parseInt(val.summary.sedentaryMinutes)
      this.fairMinutes = parseInt(val.summary.fairlyActiveMinutes)
      this.lightMinutes = parseInt(val.summary.lightlyActiveMinutes)
      this.activeMinutes = parseInt(val.summary.veryActiveMinutes)
      if(isNaN(val.summary.floors)) {
        this.achievedFloors = 0
      } else {
        this.achievedFloors = val.summary.floors
      }

      //Set percents
      this.stepsPercent = Number(this.achievedSteps/this.goalSteps*100).toFixed(0)
      this.distancePercent = Number(this.achievedDistance/this.goalDistance*100).toFixed(0)
      this.caloriePercent = Number(this.achievedCalorieOut/this.goalCalorieOut*100).toFixed(0)
      if(isNaN(this.achievedFloors)) {
        this.floorPercent = 0
      } else {
        this.floorPercent = Number(this.achievedFloors/this.goalFloors*100).toFixed(0)
      }

      this.deviceNotSynced = false
      this.summaryReady = true
    },

    //Get step count from fitbit - last sunday and previous 7 days to calculate rank
     getRankData() {
       var end = ''
       var endD = new Date()
       //If today is sunday get last sunday
       if (endD.getDay()==0) {
         endD.setDate(endD.getDate()-7)
       } else {
         endD.setDate(endD.getDate()-endD.getDay())
       }

       //Convert date format to fitbit friendly YYYY-MM-DD
       if ((endD.getMonth()+1)<10) {
         if (endD.getDate()<10) {
           end = endD.getFullYear()+'-0'+(endD.getMonth()+1)+'-0'+endD.getDate()
         } else {
           end = endD.getFullYear()+'-0'+(endD.getMonth()+1)+'-'+endD.getDate()
         }
       } else {
         if (endD.getDate()<10) {
           end = endD.getFullYear()+'-'+(endD.getMonth()+1)+'-0'+endD.getDate()
         } else {
           end = endD.getFullYear()+'-'+(endD.getMonth()+1)+'-'+endD.getDate()
         }
       }

       //Check to make sure access is granted to FITBIT Web API by checking for access token
       //Access granted -> get week data last sunday and previous 7 days for user rank
       if(this.$cookies.isKey('oauth_access_token')) {
         var AuthString = 'Bearer '+(this.$cookies.get('oauth_access_token'))
         axios.defaults.headers.common['Authorization'] = AuthString

         //Call for 7 days of data
         axios({ method: 'get',
           url: 'https://api.fitbit.com/1/user/-/activities/tracker/steps/date/'+end+'/7d.json'
         })
         .then(response => {
           var rank = JSON.stringify(response.data)
           rank = JSON.parse(rank.split('steps\":')[1].split(']}')[0]+']')

           //Sum the steps for pass to setRank
           var rankSteps = 0
           for (var key in rank) {
             rankSteps += parseInt(rank[key].value)
           }

           //Set rank in store
           if (rankSteps >= 20000 && rankSteps < 30000) {
             if (this.gender == 'Male') {
               // this.$store.dispatch('changeRank', 'Poseidon')
             } else {
               // this.$store.dispatch('changeRank', 'Artemis')
             }
           } else if (rankSteps >= 30000 && rankSteps < 40000) {
               if (this.gender == 'Male') {
                 // this.$store.dispatch('changeRank', 'Odysseus')
               } else {
                 // this.$store.dispatch('changeRank', 'Vesta')
               }
           } else if (rankSteps >= 40000 && rankSteps < 50000) {
               if (this.gender == 'Male') {
                 // this.$store.dispatch('changeRank', 'Apollo')
               } else {
                 // this.$store.dispatch('changeRank', 'Athena')
               }
           } else if (rankSteps >= 50000) {
               if (this.gender == 'Male') {
                 // this.$store.dispatch('changeRank', 'Zeus')
               } else {
                 // this.$store.dispatch('changeRank', 'Hera')
               }
           } else {
               // this.$store.dispatch('changeRank', 'No Rank')
               console.log('Set Rank State Error')
           }
         })
         .catch(error => { console.log(error); })
       } else {
         this.deviceNotSynced = true
       }
     },

      //Set rank and award badge
     setRank() {
       switch (this.user.rank) {
         case 'Zeus':
           this.rank = 'Platinum Level Achieved'
           return Zeus
           break
         case 'Poseidon':
           this.rank = 'Bronze Level Achieved'
           return Poseidon
           break
         case 'Vesta':
           this.rank = 'Silver Level Achieved'
           return Vesta
           break
         case 'Odysseus':
           this.rank = 'Silver Level Achieved'
           return Odysseus
           break
         case 'Hera':
           this.rank = 'Platinum Level Achieved'
           return Hera
           break
         case 'Athena':
           this.rank = 'Gold Level Achieved'
           return Athena
           break
         case 'Artemis':
           this.rank = 'Bronze Level Achieved'
           return Artemis
           break
         case 'Apollo':
           this.rank = 'Gold Level Achieved'
           return Apollo
           break
         case 'No Rank':
           this.rank = 'Keep Working Hard'
           return logo
           break
         default:
           console.log('Set Rank Error')
           this.rank = 'Badge Error'
           break
         }
      }
   },
   components: {
     didimoModal: didimoModal,
     usernameModal
   },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flip-container {
  -webkit-perspective: 1000px;
  -moz-perspective: 1000px;
  -o-perspective: 1000px;
  perspective: 1000px;
  min-height: inherit;
  padding-left: 22%;
}
.flipper {
  -moz-transform: perspective(1000px);
  -moz-transform-style: preserve-3d;
  position: relative;
}
.front,
.back {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.6s;
  -webkit-transform-style: preserve-3d;
  -moz-transition: 0.6s;
  -moz-transform-style: preserve-3d;
  -o-transition: 0.6s;
  -o-transform-style: preserve-3d;
  -ms-transition: 0.6s;
  -ms-transform-style: preserve-3d;
  transition: 0.6s;
  transform-style: preserve-3d;
  position: relative;
}
.front {
  z-index: 2;
}
.back {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
}
.flip-container:hover .back,
.flip-container.hover .back {
  -webkit-transform: rotateY(0deg);
  -moz-transform: rotateY(0deg);
  -o-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  transform: rotateY(0deg);
}
.flip-container:hover .front,
.flip-container.hover .front {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.ball {
  padding-left: 15%;
  margin-top: 50px;
  border-radius: 50%;
  width: 70%;
  height: 50px;
  animation: bounce 1s infinite alternate;
  -webkit-animation: bounce 1s infinite alternate;
}
@keyframes bounce {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-15px);
  }
}
@-webkit-keyframes bounce {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-15px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue